module.exports = __webpack_public_path__ + "img/4_2.d128263f.jpg";